// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"28d95bf2","168":"79d47721","396":"e0240847","514":"98dc07f7","578":"3fbc597e","655":"493e975e"}[chunkId] + ".chunk.css";
};